import firebase from './firebaseInit';
import { ImageInfo } from '@/interfaces/ImageInfo';

export const storage = firebase.storage();

// export const storageRef = storage.ref('test/test.jpg');

export function test() {
  const storageRef2 = storage.ref('test');
  storageRef2.list().then(list => {
    list.items[0].getDownloadURL().then(result2 => {
      console.log('1', result2);
    });
  });
}

export async function getImageUrls(tag: string): Promise<string[]> {
  const storageRef = storage.ref(tag);
  const list = await storageRef.list();

  console.log(list);

  const promises: Array<Promise<string>> = [];
  for (const item of list.items) {
    promises.push(item.getDownloadURL());
  }

  const imageUrls = await Promise.all(promises);
  return imageUrls;
}

export async function getImageInfos(tag: string) {
  const storageRef = storage.ref(tag);
  const list = await storageRef.list();

  const promises: Array<Promise<string>> = [];
  for (const item of list.items) {
    promises.push(item.getDownloadURL());
  }

  const imageUrls = await Promise.all(promises);

  const imageInfos: ImageInfo[] = [];
  for (let i = 0; i < list.items.length; i++) {
    imageInfos[i] = {
      fileName: list.items[i].name,
      imageUrl: imageUrls[i]
    };
  }
  return imageInfos;
}

export async function getImageUrl(
  dirname: string,
  filename: string
): Promise<string> {
  return storage.ref(`${dirname}/${filename}`).getDownloadURL();
}

export async function getTestJson() {
  storage
    .ref('test/d3basic-19983881105_e93c2d8279_b.jpg.json')
    .getDownloadURL()
    .then((url: string) => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.onload = event => {
        const json = xhr.response;
        console.warn('json', json);
      };
      xhr.open('GET', url);
      xhr.send();
    });
}

export function getImageJson<T>(dirname: string, filename: string) {
  return new Promise<T>((resolve, reject) => {
    storage
      .ref(`${dirname}/${filename}`)
      .getDownloadURL()
      .then((url: string) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'json';
        xhr.onload = event => {
          const json = xhr.response;
          resolve(json);
          // console.warn('json2', json);
        };
        xhr.open('GET', url);
        xhr.send();
      });
  });
}
